import React from 'react';
import { CompModel } from '../types/compensation';
import { formatDkk } from '../utils/format';
interface ScenarioPanelProps {
  model: CompModel;
}
export function ScenarioPanel({
  model
}: ScenarioPanelProps) {
  const max = Math.max(...model.scenarios.map(s => s.cash), 1);
  return <section aria-label="Annual cash scenarios" className="rounded-card border border-line bg-ink-900 p-6 lg:p-8" data-id="element-184" data-mp="2g4brs3dip8sl">
      <div className="flex flex-wrap items-baseline justify-between gap-3" data-id="element-185" data-mp="2b5quabpnh37u">
        <h2 className="text-[13px] font-semibold uppercase tracking-[0.2em] text-paper" data-id="element-186" data-mp="26e0ehq7y1n91">
          Annual cash scenarios
        </h2>
        <p className="text-sm text-paper-dim" data-id="element-187" data-mp="21fp2p9y392o6">
          Warrants excluded — ownership is tracked separately
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-line bg-line md:grid-cols-3" data-id="element-188" data-mp="1xbr7habvwc0e">
        {model.scenarios.map(s => {
        const isTarget = s.id === 'target';
        return <div key={s.id} className={isTarget ? 'bg-ink-800 p-5' : 'bg-ink-950 p-5'} data-id="element-189" data-mp="1vk6o5bvac0uf">
              <div className="flex items-baseline justify-between gap-2" data-id="element-190" data-mp="20czpdprjor1r">
                <p className="text-sm font-medium text-paper" data-id="element-191" data-mp="1mktbkabv6w5h">{s.label}</p>
                <p className="tnum text-xs text-paper-dim" data-id="element-192" data-mp="1riv37jncw3sk">
                  {Math.round(s.attainment * 100)}% of target
                </p>
              </div>
              <p className={['tnum mt-4 font-semibold tracking-tight text-paper', isTarget ? 'text-[28px] leading-none' : 'text-[22px] leading-none'].join(' ')} data-id="element-193" data-mp="2f9gyeac9htl5">
                {formatDkk(s.cash)}
              </p>
              <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-line" data-id="element-194" data-mp="2a7rpb08lnpzp">
                <div className="h-full rounded-full bg-security transition-[width] duration-200 ease-out" style={{
              width: `${s.cash / max * 100}%`
            }} data-id="element-195" data-mp="ttrrpvx88cfm" />
              </div>
              <dl className="tnum mt-4 space-y-1.5 text-xs" data-id="element-196" data-mp="eu5ri85ztopu">
                <div className="flex justify-between" data-id="element-197" data-mp="as0xh8bmuq2o">
                  <dt className="text-paper-dim" data-id="element-198" data-mp="5zrd07taei7s">Guaranteed</dt>
                  <dd className="text-paper-muted" data-id="element-199" data-mp="5y6lkr29rfe5">
                    {formatDkk(model.fixedAnnual)}
                  </dd>
                </div>
                <div className="flex justify-between" data-id="element-200" data-mp="3s7qzjfx24kak">
                  <dt className="text-paper-dim" data-id="element-201" data-mp="3s54qtcyfjyqr">Commission</dt>
                  <dd className="text-performance" data-id="element-202" data-mp="3n737cqx3dxer">
                    {formatDkk(s.commission)}
                  </dd>
                </div>
              </dl>
            </div>;
      })}
      </div>
    </section>;
}